// A cover image can be much wider than its visible crop, especially on phones.
function updateImageSize(image) {
  const picture = image.closest('picture');
  const source = picture
    ? [...picture.querySelectorAll('source[media]')].find((item) => matchMedia(item.media).matches)
    : null;
  const dimensions = source || image;
  const ratio = Number(dimensions.getAttribute('width')) / Number(dimensions.getAttribute('height'));
  const { width, height } = image.getBoundingClientRect();
  if (!width || !height || !Number.isFinite(ratio) || ratio <= 0) return;

  const coveredWidth = getComputedStyle(image).objectFit === 'cover' ? Math.max(width, height * ratio) : width;
  const sizes = `${Math.ceil(coveredWidth)}px`;
  if (image.sizes !== sizes) image.sizes = sizes;
  if (source && source.sizes !== sizes) source.sizes = sizes;
}

const observed = new WeakSet();
const observer = new ResizeObserver((entries) => {
  for (const { target } of entries) updateImageSize(target);
});

function handleImageLoad(event) {
  updateImageSize(event.currentTarget);
}

function observeImages(root = document) {
  for (const image of root.querySelectorAll('img.hero__media')) {
    if (observed.has(image)) continue;
    observed.add(image);
    image.addEventListener('load', handleImageLoad);
    observer.observe(image);
    updateImageSize(image);
  }
}

observeImages();
document.addEventListener('shopify:section:load', (event) => observeImages(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  for (const image of event.target.querySelectorAll('img.hero__media')) {
    observer.unobserve(image);
    image.removeEventListener('load', handleImageLoad);
    observed.delete(image);
  }
});
